module.exports = __webpack_public_path__ + "img/mercado-pago.4a37a25c.png";